import { authUrl } from "../../config";
export default async ({ auth, body }) =>
  await fetch(authUrl, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth
    },
    method: "POST",
    body: body ? body : null
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) throw res.errors;
      return res.data;
    })
    .catch(err => {
      throw err;
    });
